import { render } from "./TourCosting.vue?vue&type=template&id=b632d01a"
import script from "./TourCosting.vue?vue&type=script&lang=js"
export * from "./TourCosting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__